import logoSrc from "../../../maherLogo.png";

/**
 * Faded full-card watermark positioned absolutely behind all content.
 * Uses `direction: ltr` so it stays centred regardless of the card's RTL context.
 */
export default function WatermarkLogo() {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "15%", // optical adjustment to better center the logo with the card decorations
        opacity: 0.07,
        pointerEvents: "none",
        zIndex: 0,
        direction: "ltr",
      }}
    >
      <img src={logoSrc} alt="" style={{ width: 560, objectFit: "contain" }} />
    </div>
  );
}
